import React, { useState, useEffect } from 'react';
// import YouTube from 'react-youtube';
import placeholder from '../../assets/video-placeholder.jpg';

import { db } from '../../config/firebase';

import './VideoGallery.css';

const VideoGallery = () => {
    // const opts = {
    //     height: '400',
    //     width: '800',
    //     playerVars: {
    //         // https://developers.google.com/youtube/player_parameters
    //         autoplay: 0,
    //     },
    // };

    const [ keyArray, setKeyArray ] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        db.collection('videos').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
          setKeyArray(snapshot.docs.map(doc => ({id: doc.id, videoKey: doc.data()})));
        })
      }, []);
    
    return (
        <div className="videoGallery">
            <p className="videoGallery-title">VIDEOS</p>
            <div >
                {
                    keyArray.map(({id, videoKey}) => (
                        <div onLoad={() => setIsLoaded(true)} key={id}>
                            {
                                isLoaded ? (
                                    <div className="videoGallery-div">
                                        <iframe
                                            allowfullscreen
                                            style={{
                                                width: "100%",
                                                height: "100%"
                                                }}
                                            title="video"
                                            src={`https://www.youtube.com/embed/${videoKey.videoKey}`}
                                            frameBorder="0"
                                        />
                                    </div>
                                ) : (
                                    <img className={`video-player`} src={placeholder} alt="video-placeholder" />
                                )
                            }
                        </div>
    
                    ))
                }
            </div>
            {/* <YouTube className="video-player" videoId="XxLgFuPBOLU" opts={opts} onReady={this._onReady} />
            <YouTube className="video-player" videoId="vOIeFFOWJ4s" opts={opts} onReady={this._onReady} /> */}
        </div>
    );
    
}


export default VideoGallery;


// WEBPACK FOOTER //
// ./src/components/videoGallery/VideoGallery.js